import { Theme } from "@mui/material";
import { Chart } from "highcharts";

export const drawOrUpdateEndCircle = (
  chart: Chart,
  theme: Theme,
  handlerCircle: {
    radiusOffset: number;
    centerDistanceOffset: number;
  }
) => {
  const series = chart.series[0];
  const pieOptions = chart.options.plotOptions?.pie;
  const firstPoint = series?.data?.[0];

  if (!firstPoint || typeof firstPoint.y !== "number" || !pieOptions) {
    return;
  }

  const startAngle = pieOptions.startAngle ?? -135;
  const innerSizePct =
    (parseFloat(pieOptions.innerSize?.toString() ?? "85") || 85) / 100;

  const pointValueAngle = firstPoint.y;

  // Calculate the end angle of the first segment
  const endOfValueSegmentAngleDeg = startAngle + pointValueAngle;
  const angleRad = endOfValueSegmentAngleDeg * (Math.PI / 180);

  const cx = chart.plotLeft + chart.plotWidth * 0.5;
  const cy = chart.plotTop + chart.plotHeight * 0.5;

  // Calculate radius for the circle's position
  const plotSize = Math.min(chart.plotWidth, chart.plotHeight);
  const outerRadius = plotSize * 0.5;
  const innerRadius = outerRadius * innerSizePct;

  // Make circle radius and offset proportional to the gauge thickness
  const gaugeThickness = outerRadius - innerRadius;
  const circleRadius = gaugeThickness * handlerCircle.radiusOffset;
  const targetRadiusForCircleCenter =
    innerRadius * handlerCircle.centerDistanceOffset;

  const circleX = cx + targetRadiusForCircleCenter * Math.sin(angleRad);
  const circleY = cy - targetRadiusForCircleCenter * Math.cos(angleRad);

  const fillColor = theme.palette.common.white;
  const strokeColorWithOpacity = "#2632401F"; //N800 12% opacity
  const strokeWidth = 2;

  const endCircleElement = chart.customGaugeEndCircle;

  const circleAttributes = {
    x: circleX,
    y: circleY,
    r: circleRadius,
    fill: fillColor,
    stroke: strokeColorWithOpacity,
    "stroke-width": strokeWidth,
  };

  if (endCircleElement) {
    endCircleElement.animate(circleAttributes);
  } else {
    chart.customGaugeEndCircle = chart.renderer
      .circle()
      .attr({
        ...circleAttributes,
        zIndex: 5,
      })
      .add();
  }
};
